// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2310 ? "76a2e435" : chunkId) + "." + {"2310":"ccdb16de9d889a97","4070":"78a2413b793a227a","4863":"0480ae1b6ee3c132","4900":"02ffb1bacc824fea","5507":"3282d1f1528fa36e"}[chunkId] + ".js";
};